<div
  mat-dialog-content
  class="modal-body modal-body-edit-fields kultur-nav-fields-container"
>
  <div class="modal-main-content">
    <div class="kultur-nav-fields">
      @if (kulturNavData.concept_type_id) {
        <form class="mat-mdc-form-field-wrapper">
          <app-superobject-filter-select
            [conceptTypeId]="kulturNavData.concept_type_id"
            [parentSuperobjectTypeId]="kulturNavData.parent_superobject_type_id"
            (filterChange)="onFilterChange($event)"
          ></app-superobject-filter-select>
        </form>
      }

      @if (options && options.length > 1) {
        <form class="kultur-nav-fields__options-field">
          <mat-form-field appearance="outline">
            <mat-label>
              {{ kulturNavData.sub_type_headline | translate }}
            </mat-label>

            <mat-select [(value)]="selectedOption.value">
              @for (option of options; track option.value) {
                <mat-option [value]="option.value">
                  <span>
                    {{ option.label | translate }}
                  </span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </form>
      }

      <div>
        <form class="kultur-nav-fields__search-field ">
          <mat-form-field appearance="outline">
            <mat-label>
              {{ 'TRANS__CULTURE_HUB_IMPORTER__SEARCH_LABEL' | translate }}
            </mat-label>

            <input
              matInput
              #query
              placeholder="{{'TRANS__CULTURE_HUB_IMPORTER__SEARCH_PLACEHOLDER' | translate}}"
              [value]="initQuery"
              (change)="runSearch(query.value)"
            >

            <mat-icon
              matPrefix
              color="accent"
            >
              search
            </mat-icon>

            <button
              matSuffix
              mat-button
              type="button"
              (click)="runSearch(query.value)"
              color="accent"
            >
              <span class="uppercase bold">
                {{ 'TRANS__FILTER__SEARCH_PLACEHOLDER' | translate }}
              </span>
            </button>
          </mat-form-field>
        </form>

        <div class="kultur-nav-table-container">
          <div class="md-table admin-scroll-layout kultur-nav-table">
            <table
              mat-table
              [dataSource]="kulturNavConceptDataSource"
            >
              <caption></caption>

              <ng-container matColumnDef="selected">
                <th mat-header-cell *matHeaderCellDef></th>
                <td
                  mat-cell
                  *matCellDef="let element"
                >
                  <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (keydown)="null"
                    [checked]="!!findSelected(element)"
                    (change)="!!findSelected(element) ? deselect(element): selection.select(element)"
                  ></mat-checkbox>
                </td>
              </ng-container>

              <ng-container matColumnDef="conceptName">
                <th mat-header-cell *matHeaderCellDef>
                  <span>
                    {{ 'TRANS__CULTURE_HUB_IMPORTER__COLUMN__CONCEPT' | translate }}
                  </span>
                </th>

                <td mat-cell *matCellDef="let element">
                  <a
                    href="https://kulturnav.org/{{element.uuid}}"
                    target="_blank"
                  >
                    {{ element.conceptName }}
                  </a>
                </td>
              </ng-container>

              <ng-container matColumnDef="dataSet">
                <th mat-header-cell *matHeaderCellDef>
                  <span>
                    {{ 'TRANS__CULTURE_HUB_IMPORTER__COLUMN__DATA_SET' | translate }}
                  </span>
                </th>

                <td mat-cell *matCellDef="let element">
                  {{ element.dataSet }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="conceptColumns; sticky: true"></tr>

              <tr mat-row *matRowDef="let row; columns: conceptColumns;"></tr>

              <tr
                class="mat-row kultur-nav-table__no-data"
                *matNoDataRow
              >
                <td
                  class="mat-cell"
                  colspan="4"
                >
                  @if (query.value && noResults && !searching) {
                    <span class="tone-down-color">
                      {{ 'TRANS__CULTURE_HUB_SEARCH__NO_SEARCH_HITS' | translate }}
                    </span>
                  }
                  @else if (!query.value && !searching) {
                    <span class="tone-down-color">
                      {{ 'TRANS__CULTURE_HUB_SEARCH__NO_SEARCH' | translate }}
                    </span>
                  }
                  @else if (searching) {
                    <span class="kultur-nav-table__no-data-spinner">
                      <mat-spinner
                        color="accent"
                        diameter="16"
                      ></mat-spinner>

                      <span class="kultur-nav-table__no-data-spinner-text">
                        {{ 'TRANS__CULTURE_HUB_SEARCH__SEARCHING' | translate }}
                      </span>
                    </span>
                  }
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div class="kultur-nav-fields__selected-terms">
        <span class="bold">
          {{ 'TRANS__MODAL_DIALOG__YOU_HAVE_CHOSEN' | translate }}
        </span>

        @if (selection.selected.length > 0) {
          <mat-chip-listbox>
            @for (selected of selection.selected; track selected.uuid) {
              <mat-chip-option (removed)="deselect(selected)">
                {{ selected.conceptName }}

                <mat-icon matChipRemove>
                  cancel
                </mat-icon>
              </mat-chip-option>
            }
          </mat-chip-listbox>
        }
      </div>
    </div>
  </div>
</div>

<div
  mat-dialog-actions
  class="modal-footer dialog-border-color kultur-nav-footer-container"
>
  <span class="kultur-nav-footer-container__feedback">
    @for (error of errors; track error) {
      @if (errors.length > 1) {
        <span class="error-warn-color bold">
          {{ error | translate }}
        </span>
      }
    }
  </span>

  <button
    mat-flat-button
    [disabled]="importing || searching || selection.isEmpty()"
    color="accent"
    type="submit"
    (click)="runImport()"
  >
    @if (!importing) {
      <span class="bold">
        {{ 'TRANS__CULTURE_HUB_IMPORTER__RUN_IMPORT' | translate }}
      </span>
    }
    @else {
      <span class="kultur-nav-footer-container__downloading">
        <mat-spinner
          diameter="16"
          id="kultur-nav-downloading"
        ></mat-spinner>

        <span class="bold">
          {{ 'TRANS__CULTURE_HUB_SEARCH__IMPORTING' | translate }}
        </span>
      </span>
    }
  </button>

  <button
    mat-button
    type="button"
    color="accent"
    (click)="closeImport()"
  >
    <span class="bold">
      {{ 'TRANS__BUTTON__CLOSE' | translate }}
    </span>
  </button>
</div>
